import { transformDate } from 'lib/utils/common';
import { Message, MessageResponse } from 'types/chat';
import { transformFileResponse } from './transformFileResponse';
import { createMessageClientId } from './createMessageClientId';

export const transformMessageResponse = (message: MessageResponse): Message => {
  const { timestamp, id, rating, role, text } = message;
  const { date, time } = transformDate(timestamp);
  const clientId = createMessageClientId(id);

  if (role === 'assistant') {
    const attachments = message.attachments?.map(transformFileResponse);

    return {
      clientId,
      date,
      time,
      id,
      rating,
      role,
      text,
      model: message.mode,
      attachments,
    };
  }

  if ('attachments' in message) {
    const attachments = message.attachments.map(transformFileResponse);

    return {
      clientId,
      date,
      time,
      id,
      rating,
      role,
      text,
      attachments,
    };
  }

  return {
    clientId,
    date,
    time,
    id,
    rating,
    role,
    text,
  };
};
